type CommStatusTagProps = {
  color: string;
  status: string;
};

/**
  Returning both color and status for qds-tag elements based on commStatus key.
  It is designed to work with old and new version of qds-tag component
  after introducing status that replaced color property in
  @quartzds/core 1.0.0-beta.65 (2024-12-16)
**/
export const buildCommStatusQdsTagProps = (
  commStatusKey: string,
): CommStatusTagProps => {
    const statusMap: Record<string, CommStatusTagProps> = {
      COMMERCIALIZED: { color: 'green', status: 'success' },
      DISCONTINUED: { color: 'red', status: 'error' },
      TO_BE_DISCONTINUED: { color: 'orange', status: 'warning' }, // Fallback
    };

    return statusMap[commStatusKey] || statusMap.TO_BE_DISCONTINUED;
};
